/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Comment_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Add a comment here" |
*
* @param {Markers_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_comment_placeholder = /** @type {((inputs?: Markers_Comment_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Comment_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un commentaire ici")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier einen Kommentar hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi un commento qui")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оставьте комментарий здесь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añade un comentario aquí")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在此处添加评论")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ここにコメントを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यहां एक टिप्पणी जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicione um comentário aqui")
	return /** @type {LocalizedString} */ ("Add a comment here")
});